<template>
  <div class="video-player md:grow bg-black rounded-2xl max-h-[420px]">
    <div
      class="relative h-full w-full mx-auto"
      @click="toggleLightboxModalOpen"
    >
      <LazyEventGalleryVideoPlayerSource
        :source-stream="sourceStream"
        :source="source"
        :poster="poster"
      />
      <slot name="action-buttons" />
    </div>

    <TransitionRoot as="template" :show="isLightboxModalOpen">
      <Dialog class="relative z-100" @close="toggleLightboxModalOpen">
        <div class="fixed inset-0 flex w-screen items-center justify-center">
          <TransitionChild
            enter="duration-300 ease-out"
            enter-from="opacity-0 translate-y-full"
            enter-to="opacity-100 translate-y-0"
            leave="duration-200 ease-in"
            leave-from="opacity-100 translate-y-0"
            leave-to="opacity-0 translate-y-full"
            as="template"
          >
            <DialogPanel
              class="flex flex-col align-bottom w-full h-full bg-white"
            >
              <DialogTitle class="p-4 text-base">
                <div>
                  <Button
                    color="tertiary"
                    class="px-2 border border-gray-300 rounded-full!"
                    @click.prevent="toggleLightboxModalOpen"
                  >
                    <IconChevronDown class="rotate-90" />
                  </Button>
                </div>
              </DialogTitle>
              <DialogDescription
                as="div"
                class="p-4 overflow-x-auto video-dialog h-full items-center flex duration-300"
              >
                <LazyEventGalleryVideoPlayerSource
                  v-if="isLightboxModalOpen"
                  :source-stream="sourceStream"
                  :source="source"
                  :poster="poster"
                  is-modal
                />
              </DialogDescription>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
<script lang="ts" setup>
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue'
import IconChevronDown from '~/components/icons/IconChevronDown.vue'

const {
  source = '',
  sourceStream = '',
  poster = '',
} = defineProps<{
  source: string
  sourceStream?: string
  poster: string
}>()

const isLightboxModalOpen = ref(false)

const toggleLightboxModalOpen = () => {
  isLightboxModalOpen.value = !isLightboxModalOpen.value
}
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.video-player {
  overflow: hidden;

  video {
    @apply h-full w-full object-cover mx-auto rounded-lg;
  }
}

.video-dialog {
  overflow: hidden;

  .video-js {
    height: 100%;
    width: auto;
    position: relative;
    display: inline-flex;
  }

  video {
    position: relative !important;
    @apply rounded-lg;
  }
}
</style>
